import React, { useState, useEffect } from 'react'
import {
  Card, CardHeader, CardContent, Typography, Button,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Divider, makeStyles, Chip, Box,
  Dialog, DialogTitle, DialogContent, DialogActions,
} from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import PersonIcon from '@material-ui/icons/Person'
import PrintIcon from '@material-ui/icons/Print'
import PaymentIcon from '@material-ui/icons/Payment'
import { Link } from 'react-router-dom'
import Layout from '../components/layout/Layout'
import api from '../api/client'
import { toFarsiDigits, toEnglishDigits } from '../assets/utils'
import BillingProfileDialog from '../components/billing/BillingProfileDialog'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { userInfoState } from '../recoil/atoms'
import { logoSrc, uploadLogo } from '../api/logoSrc'
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera'
import IconButton from '@material-ui/core/IconButton'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import { TextField } from '@material-ui/core'
import InputAdornment from '@material-ui/core/InputAdornment'

const useStyles = makeStyles((theme) => ({
  root: {
    direction: 'rtl',
  },
  card: {
    background: '#f1f1f1',
    marginBottom: theme.spacing(3),
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    flexWrap: 'wrap',
  },
  subscriptionBox: {
    background: '#e8f5e9',
    borderRadius: 12,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    border: '1px solid #a5d6a7',
    textAlign: 'center',
  },
  subscriptionExpired: {
    background: '#ffebee',
    borderRadius: 12,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    border: '1px solid #ef9a9a',
    textAlign: 'center',
  },
  noData: {
    textAlign: 'center',
    padding: theme.spacing(4),
    color: '#999',
  },
}))

const formatDate = (dateString) => {
  if (!dateString) return '-'
  try {
    const date = new Date(dateString)
    return date.toLocaleDateString('fa-IR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
  } catch {
    return '-'
  }
}

// واحد پول در کل سامانه ریال است — هیچ تبدیلی انجام نمی‌شود
const formatAmount = (amount) => {
  if (!amount && amount !== 0) return '-'
  return toFarsiDigits(Number(amount).toLocaleString('fa-IR'))
}

const UserManagement = () => {
  const classes = useStyles()
  const [payments, setPayments] = useState([])
  const [subscription, setSubscription] = useState(null)
  const [loading, setLoading] = useState(true)

  const [invoiceLoadingId, setInvoiceLoadingId] = useState(null)
  // پاپ‌آپ مشخصات خریدار — قبل از صدور فاکتور
  const [billingOpen, setBillingOpen] = useState(false)
  const [pendingPaymentId, setPendingPaymentId] = useState(null)

  const userInfo = useRecoilValue(userInfoState)
  const isDept = !!(userInfo && userInfo.role === 'Department')
  const isDeptManager = !!(userInfo && userInfo.role === 'DepartmentManager')
  const [logoMsg, setLogoMsg] = useState('')
  const [logoBusy, setLogoBusy] = useState(false)
  const [deptProfile, setDeptProfile] = useState({ username: '', short_name: '', password: '' })
  const [deptSaved, setDeptSaved] = useState(false)
  // تغییرِ کلمه عبور — برای همهٔ نقش‌ها (نه فقط مدیر سازمان)
  const [currentPassword, setCurrentPassword] = useState('')
  const [myPassword, setMyPassword] = useState('')
  const [myPassword2, setMyPassword2] = useState('')
  const [showPw, setShowPw] = useState({ cur: false, next: false, rep: false, dept: false })
  const [mySaved, setMySaved] = useState(false)
  // شمارهٔ همراه + تغییرِ آن با تأییدِ پیامکی روی شمارهٔ فعلی
  const setUserInfo = useSetRecoilState(userInfoState)
  const [myMobile, setMyMobile] = useState((userInfo && userInfo.mobile) || '')
  const [phoneOpen, setPhoneOpen] = useState(false)
  const [phoneCode, setPhoneCode] = useState('')
  const [newMobile, setNewMobile] = useState('')
  const [phoneBusy, setPhoneBusy] = useState(false)
  const [phoneErr, setPhoneErr] = useState('')
  const [phoneTimer, setPhoneTimer] = useState(0)
  const [phoneOk, setPhoneOk] = useState(false)

  useEffect(() => {
    if (phoneTimer <= 0) return undefined
    const t = setInterval(() => setPhoneTimer((v) => (v <= 1 ? 0 : v - 1)), 1000)
    return () => clearInterval(t)
  }, [phoneTimer])

  // شماره‌ای که کاربر با آن وارد شده (از توکن)
  const loginMobile = (() => {
    try {
      const t = localStorage.getItem('access')
      const part = t && t.split('.')[1]
      if (!part) return ''
      const json = JSON.parse(decodeURIComponent(atob(part.replace(/-/g, '+').replace(/_/g, '/'))
        .split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')))
      return json.mobile || json.phone || ''
    } catch (e) {
      return ''
    }
  })()

  const fmtMobile = (m) => {
    const d = String(m || '').replace(/\D/g, '')
    const s = d.length === 10 ? '0' + d : d
    return s.length === 11 ? toFarsiDigits(s) : ''
  }

  // قدرت رمز: ۰ تا ۵ بر پایهٔ الزامات افتا
  const pwChecks = [
    (myPassword || '').length >= 10,
    /[a-z]/.test(myPassword) && /[A-Z]/.test(myPassword),
    /\d/.test(myPassword),
    /[^A-Za-z0-9]/.test(myPassword),
    (myPassword || '').length >= 14,
  ]
  const pwScore = pwChecks.filter(Boolean).length
  const pwColor = pwScore >= 5 ? '#2e7d32' : (pwScore >= 4 ? '#66bb6a' : (pwScore >= 3 ? '#f9a825' : '#e53935'))
  const pwLabel = !myPassword
    ? '—'
    : (pwScore >= 5 ? 'بسیار قوی' : pwScore >= 4 ? 'قوی' : pwScore >= 3 ? 'متوسط' : 'ضعیف')

  const saveMyPassword = async () => {
    setLogoMsg(''); setMySaved(false)
    if (!currentPassword) {
      setLogoMsg('کلمه عبورِ فعلی را وارد کنید.')
      return
    }
    if (!myPassword) {
      setLogoMsg('کلمه عبور جدید را وارد کنید.')
      return
    }
    if (myPassword !== myPassword2) {
      setLogoMsg('کلمه عبور و تکرار آن مطابقت ندارد.')
      return
    }
    try {
      // 9Router: مسیرِ امنِ تغییرِ رمز (رمزِ فعلی + سیاستِ افتا + توکنِ تازه)
      const res = await api.post('users/password/set/', {
        current_password: toEnglishDigits(currentPassword),
        password: toEnglishDigits(myPassword),
        password_confirm: toEnglishDigits(myPassword2),
      })
      if (res.data && res.data.tokens) {
        localStorage.setItem('access', res.data.tokens.access)
        localStorage.setItem('refresh', res.data.tokens.refresh)
        api.defaults.headers.common.Authorization = `Bearer ${res.data.tokens.access}`
      }
      setCurrentPassword(''); setMyPassword(''); setMyPassword2('')
      setMySaved(true)
    } catch (err) {
      const data = err && err.response && err.response.data
      setLogoMsg((data && (data.error || data.detail)) || 'خطا در تغییر کلمه عبور')
    }
  }

  const sendPhoneCode = async () => {
    setPhoneErr('')
    setPhoneBusy(true)
    try {
      const res = await api.post('users/phone/change/otp/')
      setPhoneTimer((res.data && res.data.expires_in) || 300)
    } catch (err) {
      const data = err && err.response && err.response.data
      setPhoneErr((data && (data.error || data.detail)) || 'ارسال کد ممکن نشد')
    } finally {
      setPhoneBusy(false)
    }
  }

  const savePhone = async () => {
    setPhoneErr('')
    const m = toEnglishDigits(String(newMobile || '').trim())
    if (!/^09\d{9}$/.test(m)) {
      setPhoneErr('شمارهٔ جدید باید ۱۱ رقم و با ۰۹ آغاز شود (مثلاً ۰۹۱۲۱۲۳۴۵۶۷).')
      return
    }
    if (!phoneCode.trim()) {
      setPhoneErr('کد تأیید را وارد کنید.')
      return
    }
    setPhoneBusy(true)
    try {
      const res = await api.post('users/phone/change/', {
        mobile: m, code: toEnglishDigits(phoneCode.trim()),
      })
      const saved = (res.data && res.data.mobile) || m
      setMyMobile(saved)
      setUserInfo((u) => (u ? { ...u, mobile: saved } : u))
      setPhoneOpen(false)
      setPhoneCode(''); setNewMobile(''); setPhoneTimer(0)
      setPhoneOk(true)
    } catch (err) {
      const data = err && err.response && err.response.data
      setPhoneErr((data && (data.error || data.detail)) || 'تغییر شماره ممکن نشد')
    } finally {
      setPhoneBusy(false)
    }
  }

  // پروفایل سازمان (نام اختصاری/نام کاربری/رمز) — فقط برای نقش اداره
  useEffect(() => {
    if (!isDept) return undefined
    api.get('users/department-profile/').then((res) => {
      setDeptProfile({
        username: (res.data && res.data.username) || '',
        short_name: (res.data && res.data.short_name) || '',
        password: '',
      })
    }).catch(() => {})
    return undefined
  }, [isDept])

  const handleLogoFile = async (e) => {
    const file = e.target.files && e.target.files[0]
    if (!file) return
    setLogoBusy(true)
    setLogoMsg('')
    try {
      await uploadLogo(file)
      setLogoMsg('با موفقیت ثبت شد ✓')
    } catch (err) {
      setLogoMsg((err && err.response && err.response.data && err.response.data.detail) || 'خطا در ارسال تصویر')
    } finally {
      setLogoBusy(false)
      e.target.value = ''
    }
  }

  const saveDeptProfile = async () => {
    setLogoMsg('')
    setDeptSaved(false)
    try {
      const payload = { short_name: deptProfile.short_name }
      if (deptProfile.username) payload.username = deptProfile.username
      if (deptProfile.password) payload.password = deptProfile.password
      const res = await api.put('users/department-profile/', payload)
      setDeptProfile((p) => ({
        ...p,
        password: '',
        username: (res.data && res.data.username) || p.username,
        short_name: (res.data && res.data.short_name) || '',
      }))
      setDeptSaved(true)
    } catch (err) {
      setLogoMsg((err && err.response && err.response.data && err.response.data.detail) || 'خطا در ذخیره')
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response = await api.get('users/my-payments/')
        if (response.data) {
          setPayments(response.data.payments || [])
          setSubscription(response.data.subscription || null)
        }
      } catch (error) {
        console.error('Error fetching payments:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  /** کلیک روی «چاپ فاکتور» → اول پاپ‌آپ مشخصات باز شود */
  const openBillingFor = (paymentId) => {
    setPendingPaymentId(paymentId)
    setBillingOpen(true)
  }

  const closeBilling = () => {
    setBillingOpen(false)
    setPendingPaymentId(null)
  }

  /** بعد از ذخیره مشخصات: صدور فاکتور و باز کردن صفحه آن */
  const issueInvoice = async () => {
    const paymentId = pendingPaymentId
    setBillingOpen(false)
    setPendingPaymentId(null)
    if (!paymentId) return

    setInvoiceLoadingId(paymentId)
    try {
      const res = await api.post(`users/invoices/payment/${paymentId}/`)
      const invoice = res.data
      // صفحه عمومی فاکتور در تب جدید باز شود
      window.open(`/invoice/${invoice.public_token}`, '_blank', 'noopener')
    } catch (err) {
      alert(err.response?.data?.detail || 'خطا در صدور فاکتور')
    } finally {
      setInvoiceLoadingId(null)
    }
  }

  return (
    <Layout>
      <div className={classes.root}>
        <Card elevation={5} className={classes.card}>
          <Box style={{
            background: 'linear-gradient(120deg,#1a237e 0%,#3949ab 55%,#5c6bc0 100%)',
            color: '#fff', padding: '18px 20px', display: 'flex',
            alignItems: 'center', gap: 14,
          }}>
            <Box style={{
              width: 52, height: 52, borderRadius: 16,
              background: 'rgba(255,255,255,.16)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <PersonIcon style={{ fontSize: 28 }} />
            </Box>
            <Box>
              <Typography style={{ fontWeight: 800, fontSize: 17 }}>مدیریت کاربر</Typography>
              <Typography style={{ fontSize: 11.5, opacity: .85 }}>
                پروفایل، رمز عبور، شمارهٔ همراه و وضعیت اشتراک شما
              </Typography>
            </Box>
            <Box style={{ flex: 1 }} />
            <Chip
              label={userInfo?.name || userInfo?.username || ''}
              style={{ background: 'rgba(255,255,255,.18)', color: '#fff', fontWeight: 700 }}
            />
          </Box>
          <Divider />
          <CardContent>
            {/* دکمه‌های عملیات */}


            {/* لوگو / عکس پروفایل */}
            <Box style={{ marginTop: 16, background: 'linear-gradient(180deg,#ffffff 0%,#f7f8ff 100%)', border: '1px solid #e3e6f2', borderRadius: 16, padding: 18, boxShadow: '0 4px 18px rgba(26,35,126,.06)' }}>
              <Box style={{ direction: 'rtl' }} display="flex" alignItems="center" gap={2} flexWrap="wrap">
                {/* عکس پروفایل — سمت راست */}
                <Box style={{ width: 84, height: 84, borderRadius: '50%', overflow: 'hidden', background: '#e8eafd', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, color: '#1a237e', flexShrink: 0, border: '3px solid #fff', boxShadow: '0 4px 14px rgba(20,30,80,.16)' }}>
                  {userInfo && userInfo.id ? (
                    <img
                      src={logoSrc(`users/logo/${userInfo.id}/`)}
                      alt=""
                      style={{ width: 84, height: 84, objectFit: 'cover' }}
                      onError={(e) => { e.target.style.display = 'none' }}
                    />
                  ) : (
                    <Typography style={{ fontWeight: 800 }}>پ</Typography>
                  )}
                </Box>
                <Box>
                  <Typography style={{ fontWeight: 800, fontSize: 14, color: '#1a237e' }}>
                    عکس / لوگوی پروفایل
                  </Typography>
                  <Button
                    component="label"
                    variant="contained"
                    disabled={logoBusy}
                    startIcon={<PhotoCameraIcon />}
                    style={{ marginTop: 8, background: 'linear-gradient(120deg,#1a237e,#3949ab)', color: '#fff', fontWeight: 700, borderRadius: 10 }}
                  >
                    {logoBusy ? 'در حال ارسال...' : 'انتخاب عکس یا دوربین'}
                    <input hidden type="file" accept="image/*" capture="environment" onChange={handleLogoFile} />
                  </Button>
                  {logoMsg && (
                    <Typography variant="body2" style={{ marginTop: 6, color: '#2e7d32', fontWeight: 700 }}>
                      {logoMsg}
                    </Typography>
                  )}
                </Box>

                <Box style={{ flex: 1 }} />

                {/* شمارهٔ همراه — سمت چپ */}
                {!isDept && (
                  <Box style={{ minWidth: 240, textAlign: 'left' }}>
                    <Typography style={{ fontSize: 11.5, color: '#8a94ad', marginBottom: 4 }}>
                      شمارهٔ همراه
                    </Typography>
                    <Typography style={{ direction: 'ltr', textAlign: 'right', fontWeight: 800, fontSize: 16, letterSpacing: 1, color: '#1a237e', fontFamily: 'Consolas, monospace' }}>
                      {fmtMobile(myMobile) || '—'}
                    </Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      style={{ marginTop: 8, borderRadius: 10, fontWeight: 700 }}
                      onClick={() => { setPhoneOpen(true); setPhoneErr(''); setPhoneOk(false) }}
                    >
                      تغییر شماره
                    </Button>
                    {String(fmtMobile(loginMobile) || '').replace(/\D/g, '') &&
                     String(fmtMobile(loginMobile)).replace(/\D/g, '') !== String(fmtMobile(myMobile) || '').replace(/\D/g, '') && (
                      <Typography style={{ fontSize: 11, color: '#8a94ad', marginTop: 6 }}>
                        شمارهٔ ورود: <span style={{ fontFamily: 'Consolas, monospace', color: '#475569' }}>{fmtMobile(loginMobile)}</span>
                      </Typography>
                    )}
                  </Box>
                )}
              </Box>
            </Box>


            {/* کلمه عبورِ من — برای همهٔ نقش‌ها (به‌جز سازمان) */}
            {!isDept && (
              <Box style={{ marginTop: 16, background: 'linear-gradient(180deg,#ffffff 0%,#f7f8ff 100%)', border: '1px solid #e3e6f2', borderRadius: 16, padding: 18, boxShadow: '0 4px 18px rgba(26,35,126,.06)' }}>
                <Typography variant="h6" gutterBottom>
                  کلمه عبورِ من
                </Typography>
                <Typography variant="body2" style={{ color: '#5a6b8c', marginBottom: 12 }}>
                  {isDeptManager
                    ? 'کلمه عبورِ این حساب را سازمان تعیین کرده است؛ هر زمان خواستید می‌توانید آن را تغییر دهید.'
                    : 'می‌توانید کلمهٔ عبورِ خود را هر زمان تغییر دهید؛ برای تأیید، رمزِ فعلی لازم است.'}
                </Typography>
                  <Box style={{ direction: 'rtl' }} display="flex" gap={3} flexWrap="wrap" alignItems="flex-start">
                  {/* ستون راست: باکس‌های رمز */}
                  <Box style={{ flex: '1 1 380px', minWidth: 300, direction: 'rtl' }}>
    <Box style={{ marginBottom: 6 }}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          type={showPw.cur ? 'text' : 'password'}
                          label="کلمه عبور فعلی *"
                          value={currentPassword}
                          onChange={(e) => setCurrentPassword(String(e.target.value || '')
                        .replace(/[^\x20-\x7E]/g, ''))}
                      inputProps={{ style: { fontFamily: 'Consolas, monospace', textAlign: 'left' }, dir: 'ltr' }}
                          dir="ltr"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockOutlinedIcon style={{ color: '#9aa1c2' }} />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton edge="end" size="small"
                                  onClick={() => setShowPw((s) => ({ ...s, cur: !s.cur }))}
                                  onMouseDown={(e) => e.preventDefault()}>
                                  {showPw.cur ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <Typography style={{ fontSize: 11.5, color: '#8a94ad', marginTop: 4, marginRight: 12 }}>
                          برای تأیید، رمزِ فعلی حساب خود را وارد کنید.
                        </Typography>
                      </Box>
                      <Box style={{ marginBottom: 6 }}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          type={showPw.next ? 'text' : 'password'}
                          label="کلمه عبور جدید *"
                          value={myPassword}
                          onChange={(e) => setMyPassword(String(e.target.value || '')
                        .replace(/[^\x20-\x7E]/g, ''))}
                      inputProps={{ style: { fontFamily: 'Consolas, monospace', textAlign: 'left' }, dir: 'ltr' }}
                          dir="ltr"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockOutlinedIcon style={{ color: '#9aa1c2' }} />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton edge="end" size="small"
                                  onClick={() => setShowPw((s) => ({ ...s, next: !s.next }))}
                                  onMouseDown={(e) => e.preventDefault()}>
                                  {showPw.next ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <Typography style={{ fontSize: 11.5, color: '#8a94ad', marginTop: 4, marginRight: 12 }}>
                          حداقل ۱۰ کاراکتر؛ ترکیبی از حروف بزرگ و کوچک، رقم و نماد.
                        </Typography>
                      </Box>
                      <Box style={{ marginBottom: 6 }}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          type={showPw.rep ? 'text' : 'password'}
                          label="تکرار کلمه عبور جدید *"
                          value={myPassword2}
                          onChange={(e) => setMyPassword2(String(e.target.value || '')
                        .replace(/[^\x20-\x7E]/g, ''))}
                      inputProps={{ style: { fontFamily: 'Consolas, monospace', textAlign: 'left' }, dir: 'ltr' }}
                          dir="ltr"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockOutlinedIcon style={{ color: '#9aa1c2' }} />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton edge="end" size="small"
                                  onClick={() => setShowPw((s) => ({ ...s, rep: !s.rep }))}
                                  onMouseDown={(e) => e.preventDefault()}>
                                  {showPw.rep ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <Typography style={{ fontSize: 11.5, color: '#8a94ad', marginTop: 4, marginRight: 12 }}>
                          همان رمز جدید را دوباره وارد کنید.
                        </Typography>
                      </Box>
                    <Box mt={2} display="flex" alignItems="center" gap={1} flexWrap="wrap">
                      <Button variant="contained" color="primary" onClick={saveMyPassword} style={{ fontWeight: 'bold' }}>
                        تغییر کلمه عبور
                      </Button>
                      {mySaved && (
                        <Typography variant="body2" style={{ color: '#2e7d32', fontWeight: 700 }}>
                          ذخیره شد ✓
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  {/* ستون چپ: الزامات افتا */}
                  <Box style={{
                    flex: '1 1 320px', minWidth: 280, direction: 'rtl',
                    border: '1px solid #dbe3f5', borderRadius: 16,
                    background: '#f7f9ff', padding: 14,
                  }}>
    <Box mt={2} style={{ background: '#fbfcff', border: '1px solid #e4e8f7', borderRadius: 14, padding: '12px 14px' }}>
                      <Box display="flex" alignItems="center" style={{ marginBottom: 10 }}>
                        <Typography style={{ fontWeight: 800, fontSize: 15, color: '#1a237e' }}>
                          الزامات رمز عبور (افتا)
                        </Typography>
                        <span style={{
                          marginRight: 'auto', fontSize: 12.5, fontWeight: 800,
                          color: pwScore >= 5 ? '#1b5e20' : (pwScore >= 3 ? '#b45309' : '#c62828'),
                        }}>
                          {pwLabel}
                        </span>
                      </Box>

                      {/* نوار قدرت رمز */}
                      <Box style={{ marginBottom: 12 }}>
                        <Box style={{ display: 'flex', gap: 4 }}>
                          {[0, 1, 2, 3, 4].map((i) => (
                            <Box key={i} style={{
                              flex: 1, height: 8, borderRadius: 999,
                              background: i < pwScore ? pwColor : '#e2e8f0',
                              transition: 'background .2s',
                            }} />
                          ))}
                        </Box>
                        <Typography style={{ fontSize: 11.5, color: '#64748b', marginTop: 6 }}>
                          {toFarsiDigits((myPassword || '').length)} کاراکتر
                        </Typography>
                      </Box>
                      {[
                        ['حداقل ۱۰ کاراکتر', myPassword.length >= 10],
                        ['حرف بزرگ و کوچک', /[a-z]/.test(myPassword) && /[A-Z]/.test(myPassword)],
                        ['حداقل یک رقم', /\d/.test(myPassword)],
                        ['حداقل یک نویسهٔ ویژه', /[^A-Za-z0-9]/.test(myPassword)],
                        ['متفاوت با نام کاربری', !!myPassword && !myPassword.toLowerCase().includes(String(deptProfile.username || '').toLowerCase())],
                      ].map(([t, ok]) => (
                        <div key={t} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '3px 0' }}>
                          <span style={{
                            width: 16, height: 16, borderRadius: '50%', flexShrink: 0,
                            background: ok ? '#2e7d32' : '#d7dcea', color: '#fff',
                            fontSize: 10, lineHeight: '16px', textAlign: 'center', fontWeight: 700,
                          }}>{ok ? '✓' : ''}</span>
                          <span style={{ fontSize: 14, color: ok ? '#1b5e20' : '#64748b', fontWeight: ok ? 700 : 400 }}>{t}</span>
                        </div>
                      ))}
                      <Typography style={{ fontSize: 10.5, color: '#94a3b8', marginTop: 8 }}>
                        رمز نمایش داده نمی‌شود و رمزِ تکراری پذیرفته نیست.
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {logoMsg && (
                  <Typography variant="body2" style={{ marginTop: 8, color: '#c62828', fontWeight: 700 }}>
                    {logoMsg}
                  </Typography>
                )}
              </Box>
            )}

            

            {/* تنظیمات حساب سازمان: نام اختصاری + نام کاربری + رمز */}
            {isDept && (
              <Box style={{ marginTop: 16, background: 'linear-gradient(180deg,#ffffff 0%,#f7f8ff 100%)', border: '1px solid #e3e6f2', borderRadius: 16, padding: 18, boxShadow: '0 4px 18px rgba(26,35,126,.06)' }}>
                <Typography variant="h6" gutterBottom>
                  تنظیمات حساب سازمان
                </Typography>
                <Box display="flex" gap={2} flexWrap="wrap">
                  <Box style={{ flex: '1 1 200px', minWidth: 190 }}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      label="نام اختصاری سازمان"
                      value={deptProfile.short_name}
                      onChange={(e) => setDeptProfile((p) => ({ ...p, short_name: e.target.value }))}
                      helperText="کنار نام سازمان در جدولها نمایش داده می‌شود"
                    />
                  </Box>
                  <Box style={{ flex: '1 1 200px', minWidth: 190 }}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      dir="ltr"
                      label="نام کاربری"
                      value={deptProfile.username}
                      onChange={(e) => setDeptProfile((p) => ({ ...p, username: e.target.value }))}
                    />
                  </Box>
                  <Box style={{ flex: '1 1 200px', minWidth: 190 }}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="outlined"
                      type={showPw.dept ? 'text' : 'password'} InputProps={{ endAdornment: (<InputAdornment position="end"><IconButton size="small" onClick={() => setShowPw((s) => ({ ...s, dept: !s.dept }))}>{showPw.dept ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}</IconButton></InputAdornment>) }}
                      dir="ltr"
                      label="کلمه عبور جدید (اختیاری)"
                      value={deptProfile.password}
                      onChange={(e) => setDeptProfile((p) => ({ ...p, password: e.target.value }))}
                    />
                  </Box>
                </Box>
                <Box mt={2} display="flex" alignItems="center" gap={1}>
                  <Button variant="contained" color="primary" onClick={saveDeptProfile} style={{ fontWeight: 'bold' }}>
                    ذخیره تنظیمات حساب
                  </Button>
                  {deptSaved && (
                    <Typography variant="body2" style={{ color: '#2e7d32', fontWeight: 700 }}>
                      ذخیره شد ✓
                    </Typography>
                  )}
                </Box>
                {logoMsg && (
                  <Typography variant="body2" style={{ marginTop: 8, color: '#c62828', fontWeight: 700 }}>
                    {logoMsg}
                  </Typography>
                )}
              </Box>
            )}

            {/* وضعیت اشتراک — مخصوص پیمانکاران؛ سازمانها و مدیران سازمان اشتراک ندارند */}
            {!isDept && !isDeptManager && subscription && (
              <Box className={
                subscription.is_subscribed && subscription.days_remaining > 0
                  ? classes.subscriptionBox
                  : classes.subscriptionExpired
              }>
                <Typography variant="h6" gutterBottom>
                  وضعیت اشتراک
                </Typography>
                {subscription.is_subscribed ? (
                  <>
                    <Chip
                      label={subscription.days_remaining > 0 ? 'فعال' : 'منقضی شده'}
                      style={{
                        backgroundColor: subscription.days_remaining > 0 ? '#4caf50' : '#f44336',
                        color: '#fff',
                        fontWeight: 'bold',
                        marginBottom: 8,
                      }}
                    />
                    {subscription.subscription_end_date && (
                      <Typography variant="body1">
                        تاریخ انقضا: {formatDate(subscription.subscription_end_date)}
                      </Typography>
                    )}
                    {subscription.days_remaining !== null && (
                      <Typography variant="body2" style={{ marginTop: 4 }}>
                        {subscription.days_remaining > 0
                          ? `${toFarsiDigits(subscription.days_remaining)} روز باقی‌مانده`
                          : 'اشتراک شما منقضی شده است'
                        }
                      </Typography>
                    )}
                  </>
                ) : (
                  <Typography variant="body1" style={{ color: '#c62828' }}>
                    اشتراک فعالی ندارید
                  </Typography>
                )}
              </Box>
            )}

            {/* جدول پرداخت‌ها — مخصوص پیمانکاران؛ سازمانها و مدیران سازمان اشتراک/پرداخت ندارند */}
            {!isDept && !isDeptManager && (
              <>
            <Typography variant="h6" gutterBottom style={{ marginTop: 16 }}>
              <PaymentIcon style={{ verticalAlign: 'middle', marginLeft: 8 }} />
              تاریخچه پرداخت‌ها
            </Typography>

            <TableContainer component={Paper} elevation={3} style={{ overflowX: 'auto', }}>
              <Table size="small">
                <TableHead>
                  <TableRow style={{ backgroundColor: '#1a237e' }}>
                    <TableCell align="center" style={{ color: '#fff', fontWeight: 'bold' }}>
                      ردیف
                    </TableCell>
                    <TableCell align="center" style={{ color: '#fff', fontWeight: 'bold' }}>
                      تاریخ پرداخت
                    </TableCell>
                    <TableCell align="center" style={{ color: '#fff', fontWeight: 'bold' }}>
                      مبلغ (ریال)
                    </TableCell>
                    <TableCell align="center" style={{ color: '#fff', fontWeight: 'bold' }}>
                      شماره پیگیری
                    </TableCell>
                    <TableCell align="center" style={{ color: '#fff', fontWeight: 'bold' }}>
                      فاکتور
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        در حال بارگذاری...
                      </TableCell>
                    </TableRow>
                  )}
                  {!loading && payments.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={5} align="center" className={classes.noData}>
                        پرداختی یافت نشد
                      </TableCell>
                    </TableRow>
                  )}
                  {!loading && payments.map((payment, index) => (
                    <TableRow key={payment.id}>
                      <TableCell align="center">
                        {toFarsiDigits(index + 1)}
                      </TableCell>
                      <TableCell align="center">
                        {formatDate(payment.pay_date)}
                      </TableCell>
                      <TableCell align="center">
                        {formatAmount(payment.amount)}
                      </TableCell>
                      <TableCell align="center" dir="ltr">
                        {payment.reference_number
                          ? toFarsiDigits(payment.reference_number)
                          : '-'
                        }
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          size="small"
                          variant="contained"
                          style={{ backgroundColor: '#ff9800', color: '#fff' }}
                          startIcon={<PrintIcon />}
                          onClick={() => openBillingFor(payment.id)}
                          disabled={invoiceLoadingId === payment.id}
                        >
                          {invoiceLoadingId === payment.id ? '...' : 'چاپ فاکتور'}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
              </>
            )}

          </CardContent>
        </Card>

        <BillingProfileDialog
          open={billingOpen}
          onClose={closeBilling}
          onConfirm={issueInvoice}
        />

        <Dialog open={phoneOpen} onClose={() => setPhoneOpen(false)} maxWidth="xs" fullWidth>
          <DialogTitle>تغییرِ شمارهٔ همراه</DialogTitle>
          <DialogContent>
            <Typography variant="body2" style={{ color: '#5a6b8c', marginBottom: 12, lineHeight: 2 }}>
              کدِ تأیید به شمارهٔ فعلی ({fmtMobile(myMobile)}) ارسال می‌شود.
            </Typography>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <Button
                variant="outlined"
                color="primary"
                onClick={sendPhoneCode}
                disabled={phoneBusy || phoneTimer > 0}
                style={{ minWidth: 110, fontWeight: 700 }}
              >
                {phoneTimer > 0
                  ? `${toFarsiDigits(Math.floor(phoneTimer / 60))}:${toFarsiDigits(String(phoneTimer % 60).padStart(2, '0'))}`
                  : 'ارسال کد'}
              </Button>
            </Box>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="کد تأیید"
              value={phoneCode}
              onChange={(e) => setPhoneCode(toEnglishDigits(e.target.value))}
              inputProps={{ maxLength: 6, style: { direction: 'ltr', textAlign: 'center' } }}
              style={{ marginBottom: 12 }}
            />
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label="شمارهٔ جدید"
              value={newMobile}
              onChange={(e) => setNewMobile(toEnglishDigits(e.target.value))}
              placeholder="09123456789"
              inputProps={{ maxLength: 11, style: { direction: 'ltr', textAlign: 'center' } }}
            />
            {phoneErr && (
              <Typography variant="body2" style={{ color: '#c62828', fontWeight: 700, marginTop: 10 }}>
                {phoneErr}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={savePhone} variant="contained" color="primary" disabled={phoneBusy}>
              {phoneBusy ? '...' : 'ذخیرهٔ شمارهٔ جدید'}
            </Button>
            <Button onClick={() => setPhoneOpen(false)}>بستن</Button>
          </DialogActions>
        </Dialog>
      </div>
    </Layout>
  )
}

export default UserManagement
